import React, { useRef, useState } from 'react';
import { Icon, Popconfirm, message } from 'antd';
import { useMutation } from '@apollo/client';
import { useHistory } from 'react-router-dom';
import { Base64 } from 'js-base64';

import generatePath from '~settings/routing';
import { pmsStatus, pmsStatusEnum } from '../constants';

import { PmsPlaceholder } from 'common/components/svgs';

import { MUTATION_UPDATE_PMS } from '../quires';

export default function PMSList({ t, list = [], refetch = () => {} }) {
  const history = useHistory();
  const indexRef = useRef();
  const [showStatusMenu, setShowStatusMenu] = useState(false);

  const [updatePMSAccount] = useMutation(MUTATION_UPDATE_PMS, {
    onCompleted: result => {
      if (result?.updatePMS?.pms?.id) {
        setShowStatusMenu(false);
        refetch();
      }
    },
    onError: e => {
      if (e) {
        message.error(e.toString());
      } else {
        message.error(t('Something wrong, please try again.'));
      }
    },
  });

  const handleOnConfirm = (status, pmsId) => {
    updatePMSAccount({
      variables: {
        input: {
          id: pmsId,
          status:
            status === pmsStatusEnum.AT_WORK ? pmsStatusEnum.TERMINATED : pmsStatusEnum.PENDING,
        },
      },
    });
  };

  const menu = (status, id) => (
    <Popconfirm
      overlayStyle={{ maxWidth: 236 }}
      placement="bottomLeft"
      title={
        status === pmsStatusEnum.AT_WORK
          ? t('cms:cms.pms_integrations.detail.header.terminate.label')
          : t('cms:cms.pms_integrations.detail.header.reopen.label')
      }
      onConfirm={() => handleOnConfirm(status, id)}
      onCancel={handleClickDownIcon}
      okText={t('cms:cms.tag_modal.header.btn.confirm')}
      cancelText={t('cms:cms.tag_modal.header.btn.cancel')}
      okType={status === pmsStatusEnum.AT_WORK ? 'danger' : 'primary'}
    >
      <div className="menu-status">
        <span>
          {status === pmsStatusEnum.AT_WORK
            ? 'Terminate'
            : t('cms:cms.pms_integrations.detail.header.status.reopen.label')}
        </span>
      </div>
    </Popconfirm>
  );

  const showActionButton = status =>
    [pmsStatusEnum.AT_WORK, pmsStatusEnum.TERMINATED].includes(status);

  const handleClickDownIcon = (idx, status) => {
    if (!showActionButton(status)) return;
    indexRef.current = showStatusMenu ? null : idx;
    setShowStatusMenu(!showStatusMenu);
  };

  const gotoDetail = pmsId => {
    history.push(
      generatePath('pmsIntegrationsDetails', {
        id: Base64.encodeURL(pmsId),
      }),
    );
  };

  return (
    <div className="list-wrapper">
      <For each="item" index="index" of={list}>
        <div key={index} className="card-wrapper">
          <div className="card-content">
            <div className="card-left">
              <div className="icon-wrapper">
                <PmsPlaceholder className="placeholder-icon" />
              </div>
              <div className="content-wrapper">
                <span className="pms-name">{item?.name}</span>
                <div className="view-details-btn" onClick={() => gotoDetail(item.id)}>
                  <span className="view-details">
                    {t('cms.properties.edit.review_modal.button.view_detail')}
                  </span>
                  <Icon type="right" className="right-icon" />
                </div>
              </div>
            </div>
            <div className="card-right">
              <div
                className="dropdown-wrapper"
                onClick={() => {
                  handleClickDownIcon(index, item.status);
                }}
              >
                {!showActionButton(item.status) ? (
                  <span className={`dropdown-status ${item.status}`}>{pmsStatus[item.status]}</span>
                ) : (
                  <>
                    <span className={`dropdown-status ${item.status}`}>
                      {pmsStatus[item.status]}
                    </span>
                    <div className="action-button">
                      <Icon
                        type="down"
                        onClick={() => {
                          handleClickDownIcon(index, item.status);
                        }}
                        className="action-icon"
                      />
                    </div>
                  </>
                )}
              </div>

              <If
                condition={
                  showActionButton(item.status) && showStatusMenu && indexRef.current === index
                }
              >
                {menu(item.status, item.id)}
              </If>
            </div>
          </div>
          <div className="card-bottom">
            {t('cms.landlord.detail.account_owner.label')}: {item?.emailAddress}
          </div>
        </div>
      </For>
    </div>
  );
}
